import { createContext, useContext } from 'react';
import type { AppConfig } from '@/config/apps/types';

const AppContext = createContext<AppConfig | null>(null);

export function AppProvider({
  config,
  children,
}: {
  config: AppConfig;
  children: React.ReactNode;
}) {
  return <AppContext value={config}>{children}</AppContext>;
}

export function useApp(): AppConfig {
  const config = useContext(AppContext);
  if (!config) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return config;
}
